module.exports = "/assets/site/images/MVM_futas.jpg?78f3f779272646d4eff93f64782c087d";